import "./SignatureCollection.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { loadProducts } from "../../data/loadProducts";

const SignatureCollection = () => {
  const [signatureProducts, setSignatureProducts] = useState([]);

  useEffect(() => {
    async function fetchProducts() {
      const data = await loadProducts();
      setSignatureProducts(
        data.filter((item) => item.isSignature === true).slice(0, 4)
      );
    }
    fetchProducts();
  }, []);

  return (
    <section className="signature">
      <div className="container">
        <div className="signature-header">
          <div>
            <span className="signature-tag">Signature Collection</span>
            <h2>Our Best Sellers</h2>
          </div>

          <Link to="/shop?filter=signature" className="signature-view">
            View All <FaArrowRight />
          </Link>
        </div>

        <div className="signature-grid">
          {signatureProducts.map((item) => (
            <Link
              key={item.id}
              to={`/product/${item.id}`}
              className="signature-card"
            >
              <div className="signature-image">
                <img src={item.image} alt={item.name} loading="lazy" />
              </div>

              <div className="signature-content">
                <span>{item.displayCategory || item.category}</span>
                <h3>{item.name}</h3>

                <div className="signature-footer">
                  <p>View Details</p>
                  <FaArrowRight />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SignatureCollection;